import React from 'react';
import ShareBlock from './ShareBlock';

const ActionBar = () => {
  return (
    <div className="actionbar">
      <ShareBlock />
    </div>
  );
};

export default ActionBar;



// WEBPACK FOOTER //
// ./src/product/views/_layout/ActionBar.js